module.exports = __webpack_public_path__ + "img/swaziland.6e224dc9.svg";